module.exports = __webpack_public_path__ + "img/supplier-serve.01b6ac28.png";